import React from "react";
import { ExpandableHeader } from "../../../../../components/ACS-Dashboard/ACS-Blocks/ExpandableHeader";
import TableSecondary from "../../../../../components/ACS-Dashboard/ACS-Blocks/TableSecondary";
import { FileText } from "lucide-react";

const ShipmentDocuments = ({
  uploadedDocs = [],
  fileTypeMap = {},
  handleDownload,
  handleDelete,
  setShowDocUploadModal,
  isCarrier,
  setSectionRef,
}) => {

  const formatUploadDateTime = (rawDateTime) => {
    if (!rawDateTime) {
      return { day: "N/A", time: "N/A" };
    }

    const date = new Date(rawDateTime);

    return {
      day: date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
      time: date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    };
  };


  return (
    <div>
      {/* ------------------------------ TITLE ------------------------------ */}
      <h2
        ref={setSectionRef?.("Documents")}
        className="text-fluid-lg font-semibold mb-fluid-2"
      >
        Documents
      </h2>

      {/* ------------------------------ TOP UPLOAD BUTTON (ONLY CARRIER) ------------------------------ */}
      {isCarrier && (
        <div className="flex justify-center mb-4">
          <button
            onClick={() => setShowDocUploadModal(true)}
            className="bg-[#223688] text-white px-6 py-2 font-semibold rounded-xl hover:bg-[#1d316b] transition"
          >
            Upload Document
          </button>
        </div>
      )}

      {/* ------------------------------ EXPANDABLE WRAPPER ------------------------------ */}
      <ExpandableHeader
        headerLabel="Uploaded Documents"
        icon={FileText}
        headerType="primary"
        initiallyExpanded={false}
      >
        <div className="space-y-4 bg-white p-fluid-3 dark:bg-acs-dark-surface text-gray-800 dark:text-acs-dark-text">

          {/* ------------------------------ TABLE ------------------------------ */}
           <TableSecondary
            headers={["Type", "Name", "Upload Day", "Upload Time", "Actions"]}
            columnWidths={["20%", "25%", "15%", "15%", "25%"]}
            data={uploadedDocs}
            renderRow={(doc) => {
               // 👈 check what fields are actually there
              const { day, time } = formatUploadDateTime(
                doc.uploadedAt ||
                doc.receiveQixieTime ||
                doc.createdAt ||
                doc.createdDate
            );


              return (
                <>
                  <td className="px-fluid-3 py-fluid-2 text-fluid-sm text-gray-700">
                    {fileTypeMap[doc.type] || doc.type}
                  </td>
                  <td className="px-fluid-3 py-fluid-2 text-fluid-sm text-gray-700">
                    {doc.name}
                  </td>
                  <td className="px-fluid-3 py-fluid-2 text-fluid-sm text-gray-700">
                    {day}
                  </td>
                  <td className="px-fluid-3 py-fluid-2 text-fluid-sm text-gray-700">
                    {time}
                  </td>
                  <td className="px-fluid-3 py-fluid-2 text-fluid-sm text-gray-700 flex gap-4">
                    <button
                      onClick={() => handleDownload(doc.name)}
                      className="text-[#223688] hover:underline"
                    >
                      Download
                    </button>
                    <button
                      onClick={() => handleDelete(doc.id)}
                      className="text-red-600 hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </>
              );
            }}
          />

          {/* ------------------------------ FOOTER ADD BUTTON  ------------------------------ */}
          
            <div className="flex items-center justify-between pt-4 border-t border-gray-200 dark:border-acs-dark-border mt-4">
              <button
                onClick={() => setShowDocUploadModal(true)}
                className="px-4 py-2 rounded text-sm bg-gray-600 text-white hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400"
              >
                Add Shipment Document
              </button>
            </div>
        
        </div>
      </ExpandableHeader>
    </div>
  );
};

export default ShipmentDocuments;
